import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import {
  evaluateApplication,
  feedback,
  finishApplication,
  passQuiz
} from 'store/lesson-actions';

import Loading from 'components/UI/Loading/Loading';
import RadioQuestion from './RadioQuestion/RadioQuestion';
import CheckQuestion from './CheckQuestion/CheckQuestion';
import InputQuestion from './InputQuestion/InputQuestion';
import classes from './Questions.module.css';

const Questions = props => {
  const { t } = useTranslation(['lesson']);
  const dataAcademy = useSelector(state => state.academyInfo);
  const [loading, setLoading] = useState(false);
  const [nextQuestionBtn, setNexQuestionBtn] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const changeQuestionHandler = nextQuestion => () => {
    setCurrentQuestion(currentQuestion + nextQuestion);
    setNexQuestionBtn(false);
  };

  const nextQuestionHandler = () => {
    setNexQuestionBtn(true);
  };

  const finishQuizHandler = () => {
    setLoading(true);
    (async () => {
      const finishQuiz = await finishApplication(
        props.idApplication,
        dataAcademy.data.shortName
      );
      if (finishQuiz) {
        const evaluate = await evaluateApplication(
          props.idApplication,
          dataAcademy.data.shortName,
          dataAcademy.data.shortName,
          100
        );
        if (evaluate) {
          const feedbackData = await feedback(
            props.idQuiz,
            evaluate.score
          );
          if (feedbackData) {
            const calification = await passQuiz(props.idApplication);
            if (calification) {
              if (!calification.autoEvaluate) {
                props.changeQuizStatus(2);
              } else {
                if (calification.pass) {
                  props.changeQuizStatus(2);
                } else {
                  props.changeQuizStatus(1);
                }
              }
              props.showFeedback(
                feedbackData,
                calification,
                evaluate
              );
            }
          }
        }
      }
    })();
  };

  return (
    <>
      <div className={classes.quizContainer}>
        <p className={classes.questionsInfo}>
          {t('reagent')}:{' '}
          <span className={classes.question}>{currentQuestion}</span>{' '}
          / {props.questions.length}
        </p>
        {props.questions.map(
          question =>
            question.order === currentQuestion &&
            (question.type === 1 ? (
              <RadioQuestion
                key={question.idQuestion}
                questionData={question}
                idApplication={props.idApplication}
                currentQuestion={currentQuestion}
                nextQuestion={nextQuestionHandler}
              />
            ) : question.type === 9 ? (
              <CheckQuestion
                key={question.idQuestion}
                questionData={question}
                idApplication={props.idApplication}
                currentQuestion={currentQuestion}
                nextQuestion={nextQuestionHandler}
              />
            ) : (
              <InputQuestion
                key={question.idQuestion}
                questionData={question}
                idApplication={props.idApplication}
                currentQuestion={currentQuestion}
                nextQuestion={nextQuestionHandler}
              />
            ))
        )}
      </div>
      <aside className={classes.btnsContainer}>
        {!loading ? (
          <>
            <Button
              onClick={
                currentQuestion > 1
                  ? changeQuestionHandler(-1)
                  : props.changeView
              }
              className={classes.nextBtn}
            >
              <ChevronLeftIcon /> {t('previous')}
            </Button>
            <Button
              disabled={!nextQuestionBtn}
              onClick={
                currentQuestion === props.questions.length
                  ? finishQuizHandler
                  : changeQuestionHandler(1)
              }
              className={classes.nextBtn}
            >
              {currentQuestion === props.questions.length
                ? t('save')
                : t('next')}{' '}
              <ChevronRightIcon />
            </Button>
          </>
        ) : (
          <Loading />
        )}
      </aside>
    </>
  );
};

Questions.propTypes = {
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  questions: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  idApplication: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idQuiz: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  showFeedback: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeQuizStatus: PropTypes.func
};

export default Questions;
